// This file is auto-generated by @hey-api/openapi-ts

import type {
  Options as ClientOptions,
  TDataShape,
  Client,
} from "@hey-api/client-next";
import type {
  AppControllerGetHelloData,
  AppControllerGetHelloResponse,
  HealthControllerGetReadinessData,
  HealthControllerGetReadinessResponse,
  HealthControllerGetLivenessData,
  HealthControllerGetLivenessResponse,
  HealthControllerGetCoffeeData,
  HealthControllerGetCoffeeError,
  HealthControllerGetUnhandledErrorData,
  HealthControllerGetUnhandledErrorError,
  GroupKitChatControllerSendMessageData,
  GroupKitChatControllerSendMessageResponse,
  GroupKitChatControllerResolveToolApprovalData,
  GroupKitChatControllerResolveToolApprovalResponse,
  GroupKitChatControllerGenerateConversationNameData,
  GroupKitChatControllerGenerateConversationNameResponse,
  LibraryFilesControllerGetLibraryFileData,
  GroupKitDocumentControllerCreateDocumentData,
  GroupKitDocumentControllerCreateDocumentResponse,
  GroupKitDocumentControllerCreateResearchProcessData,
  GroupKitDocumentControllerCreateResearchProcessResponse,
  FileControllerParseStartData,
  FileControllerParseMarkdownAndNodesData,
  FileControllerParseNodeEmbedData,
  FileControllerParseNodeSummaryData,
  FileControllerParseFolderSummaryData,
  FileControllerCheckNodeSummariesData,
  FileControllerCheckNodeEmbeddingsData,
  FileControllerParseFinishData,
  KitControllerRagSearchData,
  KitControllerRagSearchResponse,
  GroupKitInterviewControllerCondenseInterviewData,
  GroupKitInterviewControllerCondenseInterviewResponse,
  GroupKitInterviewControllerDownloadTranscriptData,
  GroupKitInterviewControllerDownloadTranscriptResponse,
  GroupKitSummaryControllerCreateSummaryData,
  GroupKitSummaryControllerCreateSummaryResponse,
  GroupKitSkillControllerGenerateMetadataDescriptionData,
  GroupKitSkillControllerGenerateMetadataDescriptionResponse,
  GroupKitTemplateControllerCreateTemplateData,
  GroupKitTemplateControllerCreateTemplateResponse,
  GeminiThinkingStreamControllerStreamResearchThinkingData,
  PromptControllerGetBaseNamesData,
  PromptControllerGetBaseNamesResponse,
} from "./types.gen";
import { client as _heyApiClient } from "./client.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = ClientOptions<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

export const appControllerGetHello = <ThrowOnError extends boolean = false>(
  options?: Options<AppControllerGetHelloData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    AppControllerGetHelloResponse,
    unknown,
    ThrowOnError
  >({
    url: "/brain/api/v1",
    ...options,
  });
};

/**
 * Check if service is ready to serve.
 */
export const healthControllerGetReadiness = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<HealthControllerGetReadinessData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    HealthControllerGetReadinessResponse,
    unknown,
    ThrowOnError
  >({
    url: "/brain/api/v1/health/ready",
    ...options,
  });
};

/**
 * Check if service is alive.
 */
export const healthControllerGetLiveness = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<HealthControllerGetLivenessData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    HealthControllerGetLivenessResponse,
    unknown,
    ThrowOnError
  >({
    url: "/brain/api/v1/health/live",
    ...options,
  });
};

/**
 * Forces teapot error.
 */
export const healthControllerGetCoffee = <ThrowOnError extends boolean = false>(
  options?: Options<HealthControllerGetCoffeeData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    unknown,
    HealthControllerGetCoffeeError,
    ThrowOnError
  >({
    url: "/brain/api/v1/health/coffee",
    ...options,
  });
};

/**
 * Forces unhandled error.
 */
export const healthControllerGetUnhandledError = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<HealthControllerGetUnhandledErrorData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    unknown,
    HealthControllerGetUnhandledErrorError,
    ThrowOnError
  >({
    url: "/brain/api/v1/health/unhandled-error",
    ...options,
  });
};

export const groupKitChatControllerSendMessage = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitChatControllerSendMessageData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    GroupKitChatControllerSendMessageResponse,
    unknown,
    ThrowOnError
  >({
    url: "/brain/api/v1/groups/{groupUuid}/kits/{kitUuid}/chats/{chatUuid}/messages",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupKitChatControllerResolveToolApproval = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitChatControllerResolveToolApprovalData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    GroupKitChatControllerResolveToolApprovalResponse,
    unknown,
    ThrowOnError
  >({
    url: "/brain/api/v1/groups/{groupUuid}/kits/{kitUuid}/chats/{chatUuid}/tool-approvals",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupKitChatControllerGenerateConversationName = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GroupKitChatControllerGenerateConversationNameData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).post<
    GroupKitChatControllerGenerateConversationNameResponse,
    unknown,
    ThrowOnError
  >({
    url: "/brain/api/v1/groups/{groupUuid}/kits/{kitUuid}/chats/generate-name",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const libraryFilesControllerGetLibraryFile = <
  ThrowOnError extends boolean = false,
>(
  options: Options<LibraryFilesControllerGetLibraryFileData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    url: "/brain/api/v1/library-files/{uuid}",
    ...options,
  });
};

export const groupKitDocumentControllerCreateDocument = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitDocumentControllerCreateDocumentData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    GroupKitDocumentControllerCreateDocumentResponse,
    unknown,
    ThrowOnError
  >({
    url: "/brain/api/v1/groups/{groupUuid}/kits/{kitUuid}/documents/express",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupKitDocumentControllerCreateResearchProcess = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GroupKitDocumentControllerCreateResearchProcessData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).post<
    GroupKitDocumentControllerCreateResearchProcessResponse,
    unknown,
    ThrowOnError
  >({
    url: "/brain/api/v1/groups/{groupUuid}/kits/{kitUuid}/documents/research",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const fileControllerParseStart = <ThrowOnError extends boolean = false>(
  options: Options<FileControllerParseStartData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/brain/api/v1/files/{fileUuid}/start-parsing",
      ...options,
    },
  );
};

export const fileControllerParseMarkdownAndNodes = <
  ThrowOnError extends boolean = false,
>(
  options: Options<FileControllerParseMarkdownAndNodesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/brain/api/v1/files/{fileUuid}/markdown-and-nodes",
      ...options,
    },
  );
};

export const fileControllerParseNodeEmbed = <
  ThrowOnError extends boolean = false,
>(
  options: Options<FileControllerParseNodeEmbedData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/brain/api/v1/files/{fileUuid}/nodes/{nodeUuid}/embed",
      ...options,
    },
  );
};

export const fileControllerParseNodeSummary = <
  ThrowOnError extends boolean = false,
>(
  options: Options<FileControllerParseNodeSummaryData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/brain/api/v1/files/{fileUuid}/nodes/{nodeUuid}/summary",
      ...options,
    },
  );
};

export const fileControllerParseFolderSummary = <
  ThrowOnError extends boolean = false,
>(
  options: Options<FileControllerParseFolderSummaryData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/brain/api/v1/files/{fileUuid}/folder-summary",
      ...options,
    },
  );
};

export const fileControllerCheckNodeSummaries = <
  ThrowOnError extends boolean = false,
>(
  options: Options<FileControllerCheckNodeSummariesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/brain/api/v1/files/{fileUuid}/nodes-summary-check",
      ...options,
    },
  );
};

export const fileControllerCheckNodeEmbeddings = <
  ThrowOnError extends boolean = false,
>(
  options: Options<FileControllerCheckNodeEmbeddingsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/brain/api/v1/files/{fileUuid}/nodes-embedding-check",
      ...options,
    },
  );
};

export const fileControllerParseFinish = <ThrowOnError extends boolean = false>(
  options: Options<FileControllerParseFinishData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/brain/api/v1/files/{fileUuid}/finish-parsing",
      ...options,
    },
  );
};

export const kitControllerRagSearch = <ThrowOnError extends boolean = false>(
  options: Options<KitControllerRagSearchData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    KitControllerRagSearchResponse,
    unknown,
    ThrowOnError
  >({
    url: "/brain/api/v1/groups/{groupUuid}/kits/{kitUuid}/rag-search",
    ...options,
  });
};

export const groupKitInterviewControllerCondenseInterview = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GroupKitInterviewControllerCondenseInterviewData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).post<
    GroupKitInterviewControllerCondenseInterviewResponse,
    unknown,
    ThrowOnError
  >({
    url: "/brain/api/v1/groups/{groupUuid}/kits/{kitUuid}/interviews/condense",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupKitInterviewControllerDownloadTranscript = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GroupKitInterviewControllerDownloadTranscriptData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).post<
    GroupKitInterviewControllerDownloadTranscriptResponse,
    unknown,
    ThrowOnError
  >({
    url: "/brain/api/v1/groups/{groupUuid}/kits/{kitUuid}/interviews/download-transcript",
    ...options,
  });
};

export const groupKitSummaryControllerCreateSummary = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitSummaryControllerCreateSummaryData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    GroupKitSummaryControllerCreateSummaryResponse,
    unknown,
    ThrowOnError
  >({
    url: "/brain/api/v1/groups/{groupUuid}/kits/{kitUuid}/summary",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupKitSkillControllerGenerateMetadataDescription = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GroupKitSkillControllerGenerateMetadataDescriptionData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).post<
    GroupKitSkillControllerGenerateMetadataDescriptionResponse,
    unknown,
    ThrowOnError
  >({
    url: "/brain/api/v1/groups/{groupUuid}/kits/{kitUuid}/skills/{skillUuid}/generate-metadata-description",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupKitTemplateControllerCreateTemplate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitTemplateControllerCreateTemplateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    GroupKitTemplateControllerCreateTemplateResponse,
    unknown,
    ThrowOnError
  >({
    url: "/brain/api/v1/groups/{groupUuid}/kits/{kitUuid}/templates",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const geminiThinkingStreamControllerStreamResearchThinking = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GeminiThinkingStreamControllerStreamResearchThinkingData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/brain/api/v1/groups/{groupUuid}/kits/{kitUuid}/documents/{documentUuid}/research-thinking",
    ...options,
  });
};

export const promptControllerGetBaseNames = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PromptControllerGetBaseNamesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    PromptControllerGetBaseNamesResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/brain/api/v1/prompts/base-names",
    ...options,
  });
};
